export default "__VITE_ASSET__BxHzrINj__"